var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2008 47.25H8.80078C7.00585 47.25 5.55078 45.7949 5.55078 44V4C5.55078 2.20507 7.00586 0.75 8.80078 0.75H28.8008C28.986 0.75 29.1637 0.823595 29.2947 0.954594L42.2462 13.9061C42.3772 14.0371 42.4508 14.2147 42.4508 14.4V44C42.4508 45.7949 40.9957 47.25 39.2008 47.25Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 0.599609V10.3996C28.8008 12.6087 30.5916 14.3996 32.8008 14.3996H42.6008",
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27L15 31M19.5 23L19.5 35M24 20V38M28.5 23V35M33 27V31",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAudioIcon);
export default __webpack_public_path__ + "static/media/file-audio-icon.e004760d652bae48138582606d703905.svg";
export { ForwardRef as ReactComponent };